import Link from 'next/link'

export function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="logo">
              <div className="logo-mark">S</div>
              <div className="logo-text">Servd</div>
            </div>
            <p>Planning, trainer-app en cursisten-app in één omgeving. Minder losse administratie, meer overzicht voor je tennisschool.</p>
          </div>
          <div>
            <div className="footer-col-title">Product</div>
            <div className="footer-links">
              <Link href="/tennisschool-software" className="footer-link">Tennisschool software</Link>
              <Link href="/lesplanning" className="footer-link">Lesplanning</Link>
              <Link href="/trainer-app" className="footer-link">Trainer-app</Link>
              <Link href="/cursisten-app" className="footer-link">Cursisten-app</Link>
              <Link href="/groepschat" className="footer-link">Groepschat</Link>
              <Link href="/aanwezigheidsregistratie" className="footer-link">Aanwezigheidsregistratie</Link>
              <Link href="/inhaallessen" className="footer-link">Inhaallessen</Link>
              <Link href="/boekhoudkoppeling" className="footer-link">Boekhoudkoppeling</Link>
              <Link href="/pricing" className="footer-link">Prijzen</Link>
            </div>
          </div>
          <div>
            <div className="footer-col-title">Vergelijken &amp; hulp</div>
            <div className="footer-links">
              <Link href="/vergelijking" className="footer-link">Vergelijking</Link>
              <Link href="/planmysport-alternatief" className="footer-link">PlanMySport alternatief</Link>
              <Link href="/racketclass-alternatief" className="footer-link">Racketclass alternatief</Link>
              <Link href="/faq" className="footer-link">FAQ</Link>
              <Link href="/contact" className="footer-link">Contact</Link>
            </div>
          </div>
          <div>
            <div className="footer-col-title">Legal</div>
            <div className="footer-links">
              <Link href="/privacy" className="footer-link">Privacy</Link>
              <Link href="/voorwaarden" className="footer-link">Voorwaarden</Link>
              <Link href="/cookies" className="footer-link">Cookies</Link>
              <Link href="/account-verwijderen" className="footer-link">Account verwijderen</Link>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© 2026 Nine Lives Software · De Nieuwe Erven 3, 5431 NV Cuijk</span>
          <Link href="/contact">Contactformulier</Link>
        </div>
      </div>
    </footer>
  )
}
